'use strict'

export const UNIT = {
  default: 'em'
}
